import React from 'react';

import './index.scss';

const Pending: React.FC = () => {
  return (
    <div className="a__popupMessage_pending">
      <div className="w__title">送信不可について</div>
      <div className="b__note">
        メールアドレスや携帯番号に間違いがある場合、安否確認の送信が
        <b>送信不可</b>となり、通知が送信されません。
        <b>送信不可</b>になる可能性があるユーザーは以下の様なユーザーです。
        <ul>
          <li>メール配信エラーになっている。</li>
          <li>携帯番号が登録されていない。</li>
          <li>携帯番号の形式が正しくない。</li>
        </ul>
      </div>
    </div>
  );
};

export default Pending;
